var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex p-20 justify-content-center" }, [
    _c("div", { staticClass: "welcome-card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "welcome-card-item" }, [
        _c("div", [
          _c("h1", [_vm._v(_vm._s(_vm._f("trans")("AI Creator Studio")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "Choose from various artistic styles, use the prompt editor for inspiration, and discover our advanced settings.Watch as our advanced AI generates stunning images, bringing your creativity to life!"
                )
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "welcome-card-item" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "welcome-card-content" }, [
          _c("h2", [
            _vm._v(
              "\n          " +
                _vm._s(_vm._f("trans")("Choose a Style")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "With our advanced AI technology, you can now transform your images into captivating works of art by choosing from a wide range of artistic styles. Whether you prefer classic oil paintings, abstract masterpieces, or modern digital art, our AI-powered style transfer feature can seamlessly apply the chosen style to your images, giving them a unique and eye-catching appearance."
                )
              )
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          alt: "Landing image",
          src: require("./../assets/images/landing-img@2x.png"),
          srcset:
            require("./../assets/images/landing-img@1x.png") +
            " 1x, " +
            require("./../assets/images/landing-img@2x.png") +
            " 2x, " +
            require("./../assets/images/landing-img@3x.png") +
            " 3x, " +
            require("./../assets/images/landing-img@4x.png") +
            " 4x",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "welcome-card-icon" }, [
      _c("i", { staticClass: "far fa-2x fa-style" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }